var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNewBrandmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.7787C0 21.7061 3.18323 24.8893 7.11065 24.8893V0H0Z",
    fill: "#3F4C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 31.9998V24.8892L7.11065 24.8893C7.11065 28.8168 10.2939 31.9998 14.2213 31.9998H21.334Z",
    fill: "#3F4C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2234 7.11066V0C18.1508 0 21.334 3.18324 21.334 7.11066H14.2234Z",
    fill: "#3F4C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewBrandmark);
export default __webpack_public_path__ + "static/media/logo-new-brandmark.a8c0c6af7da9ec20301dd1a9f59d5108.svg";
export { ForwardRef as ReactComponent };